import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "hiddenInput"]
  
  connect() {
    console.log("🚀 SIMPLE FILE UPLOAD CONTROLLER CONNECTED! 🚀")
    this.element.textContent = "Simple file upload connected!"
    setTimeout(() => {
      this.setupFileUpload()
    }, 1000)
  }
  
  setupFileUpload() {
    // Create file input
    this.fileInput = document.createElement('input')
    this.fileInput.type = 'file'
    this.fileInput.multiple = true
    this.fileInput.accept = '.pdf,.doc,.docx,.xls,.xlsx,.txt,.jpeg,.jpg,.png,.gif,.zip,.rar'
    this.fileInput.style.display = 'none'
    this.element.appendChild(this.fileInput)
    
    // Create table container for file previews
    this.tableContainer = document.createElement('div')
    this.tableContainer.className = 'mt-4 hidden'
    this.tableContainer.innerHTML = `
      <div class="overflow-hidden rounded-md border border-gray-200">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th scope="col" class="px-3 py-2 text-left text-[10px] font-medium text-gray-500">Nome</th>
              <th scope="col" class="px-3 py-2 text-left text-[10px] font-medium text-gray-500">Tamanho</th>
              <th scope="col" class="px-3 py-2 text-right text-[10px] font-medium text-gray-500">Ações</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200" id="files-tbody">
          </tbody>
        </table>
      </div>
    `
    this.element.parentNode.insertBefore(this.tableContainer, this.element.nextSibling)
    this.tableBody = this.tableContainer.querySelector('#files-tbody')
    
    this.selectedFiles = []
    
    // Click to select files
    this.element.addEventListener('click', () => {
      this.fileInput.click()
    })
    
    // File input change
    this.fileInput.addEventListener('change', (e) => {
      this.handleFiles(Array.from(e.target.files))
    })
    
    // Drag and drop
    this.setupDragAndDrop()
    
    // Form submission
    this.element.closest('form').addEventListener('submit', (e) => {
      e.preventDefault()
      
      if (this.selectedFiles.length > 0) {
        const formData = new FormData(this.element.closest('form'))
        formData.delete('files')
        
        this.selectedFiles.forEach(file => {
          formData.append('files[]', file)
        })
        
        fetch(this.element.closest('form').action, {
          method: 'POST',
          body: formData,
          headers: {
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
          }
        }).then(response => {
          if (response.ok) {
            window.location.reload()
          }
        })
      }
    })
  }
  
  handleFiles(files) {
    console.log("Files selected:", files.length)
    this.selectedFiles = files
    this.updateTable()
    this.updateSubmitButton()
  }
  
  updateTable() {
    if (this.selectedFiles.length > 0) {
      this.tableContainer.classList.remove('hidden')
      
      this.tableBody.innerHTML = this.selectedFiles.map((file, index) => `
        <tr class="hover:bg-gray-50">
          <td class="px-3 py-2 text-[10px] font-medium text-gray-900">
            <div class="flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-3 h-3 mr-1.5 text-blue-500">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
              </svg>
              <span class="truncate" title="${file.name}">${file.name}</span>
            </div>
          </td>
          <td class="px-3 py-2 text-[9px] text-gray-500">
            <span class="bg-gray-100 px-1 py-0.5 rounded-full">${this.formatFileSize(file.size)}</span>
          </td>
          <td class="px-3 py-2 text-right">
            <button type="button" onclick="this.closest('[data-controller]').stimulus.controller.removeFile(${index})" class="bg-white rounded-full p-1 shadow-sm hover:bg-red-50 transition-colors" title="Remover">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-3 h-3 text-red-600">
                <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
              </svg>
            </button>
          </td>
        </tr>
      `).join('')
    } else {
      this.tableContainer.classList.add('hidden')
    }
  }
  
  updateSubmitButton() {
    if (this.hasSubmitButtonTarget) {
      if (this.selectedFiles.length > 0) {
        this.submitButtonTarget.classList.remove('hidden')
      } else {
        this.submitButtonTarget.classList.add('hidden')
      }
    }
  }
  
  removeFile(index) {
    console.log("Removing file at index:", index)
    this.selectedFiles.splice(index, 1)
    this.updateTable()
    this.updateSubmitButton()
  }
  
  setupDragAndDrop() {
    console.log("Setting up drag and drop...")
    
    // Prevent default drag behaviors
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      this.element.addEventListener(eventName, this.preventDefaults.bind(this), false)
      document.body.addEventListener(eventName, this.preventDefaults.bind(this), false)
    })

    // Highlight drop area when item is dragged over it
    ['dragenter', 'dragover'].forEach(eventName => {
      this.element.addEventListener(eventName, this.highlight.bind(this), false)
    })

    ['dragleave', 'drop'].forEach(eventName => {
      this.element.addEventListener(eventName, this.unhighlight.bind(this), false)
    })

    // Handle dropped files
    this.element.addEventListener('drop', this.handleDrop.bind(this), false)
  }
  
  preventDefaults(e) {
    e.preventDefault()
    e.stopPropagation()
  }

  highlight(e) {
    console.log("Drag highlight")
    this.element.classList.add('bg-indigo-50', 'border-indigo-300')
  }

  unhighlight(e) {
    console.log("Drag unhighlight")
    this.element.classList.remove('bg-indigo-50', 'border-indigo-300')
  }

  handleDrop(e) {
    console.log("Files dropped!")
    const dt = e.dataTransfer
    const files = dt.files
    this.handleFiles(Array.from(files))
  }
  
  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }
}